import api from '../../api/'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: 1,
            montant_min: "",
            montant_max: "",
            tarif: "",
            grilletarifaire_libelle: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                montant_min: element.montant_min.toLocaleString(),
                montant_max: element.montant_max.toLocaleString(),
                tarif: element.tarif.toLocaleString(),
                grilletarifaire_libelle: element.grilletarifaire_libelle,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setTarifications(state, tarifications) {
        state.all = tarifications
    },
    addTarifications(state, tarification) {
        state.all.push(tarification)
    }
}

const actions={
    get_all_tarifications({ commit }, serverParams){
        return api.tarification.get_all_tarifications(serverParams).then((response)=>{
            commit('setTarifications', response.data.data.data)
            return response.data.data
        })
    },
    get_all_tarifications_by_grille({ commit }, serverParams){
        console.log(serverParams)
        return api.tarification.get_all_tarifications_by_grille(serverParams).then((response)=>{
            commit('setTarifications', response.data.data.data)
            return response.data.data
        })
    },
    post_tarifications({ commit }, tarification){
        return api.tarification.post_tarifications(tarification).then((response)=>{
            //commit('addTarifications', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    put_tarifications({ commit }, data){
        return api.tarification.put_tarifications(data.id,data.tarification).then((response)=>{
            //commit('addTarifications', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    show_tarifications({ commit }, id) {
        return api.tarification.show_tarifications(id).then((response) => {
            return response.data.data;
        })
        .catch(error => {
            return error.response.data
        })
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
